const getName = (context, object) => {
  context.commit("DASHBOARD_NAME_UPDATED", object.name);
};

const setShowPerPage = (context, payload) => {
  localStorage.setItem(`${payload.key}-emails-per-page`, payload.perPage);
  context.commit("SET_SHOW_PER_PAGE", payload);
};

const initialiseStore = (context, { key, perPage }) => {
  context.commit("INITIALISE_STORE", { key, perPage });
};

export default {
  getName,
  setShowPerPage,
  initialiseStore,
};
